<div class="row g-2">
  @for (field of config.fields; track field) {
  <div [class]="`col-${fieldSpan[field.span]}`">
    @if(field.type == 'input'){
    <text-input-component
      [config]="field.config"
      [value]="formData()[field.config.fieldName]"
      [listeners]="formFieldsListener"
    />
    } @if(field.type == 'select'){
    <custom-selectbox-component
      [config]="field.config"
      [value]="formData()[field.config.fieldName]"
      [listeners]="formFieldsListener"
    />
    }
  </div>
  }
</div>
